export default (config: { mock?: boolean; setup: () => void }) => {
  const { mock = process.env.REACT_APP_USE_MOCK === "true", setup } = config;
  if (mock === false) return;
  setup();
};
